import { Helmet } from "react-helmet-async";

const SITE_URL = "https://darksidedetailing.ca";
const DEFAULT_IMAGE = `${SITE_URL}/darkside-logo-horizontal.png`;

/**
 * Reusable SEO component — dynamic per route.
 * Provides <title>, meta description, canonical, OG, Twitter, and JSON-LD.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  keywords = "",
  type = "website",
  jsonLd = null,
  noindex = false,
  publishedTime = null,
  modifiedTime = null,
}) {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title.includes("Darkside Detailing")
    ? title
    : `${title} · Darkside Detailing`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Darkside Detailing" />
      <meta property="og:locale" content="en_CA" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd])}
        </script>
      )}
    </Helmet>
  );
}

export { SITE_URL, DEFAULT_IMAGE };
